module.exports = __webpack_public_path__ + "img/DE01665.5a392dfc.svg";